export default defineNuxtRouteMiddleware((to) => {
	const isDisabled = to?.matched.some(record => record.meta?.disabled)
	if (isDisabled) return navigateTo('/:role()/home')
})
